(function () {
  const CHAT_SELECTOR = '#shopify-chat > inbox-online-store-chat';
  const STYLE_ID = 'ssc-shopify-chat-resize';
  const CHAT_HEIGHT = '40px';
  const MOBILE_BOTTOM = '28px';
  const mqDesktop = window.matchMedia('(min-width: 768px)');

  function applyChatHostLayout(shadowHost) {
    var changed = false;

    if (shadowHost.style.height !== CHAT_HEIGHT) {
      shadowHost.style.height = CHAT_HEIGHT;
      changed = true;
    }

    if (mqDesktop.matches) {
      if (shadowHost.dataset.sscChatBottom) {
        shadowHost.style.removeProperty('bottom');
        delete shadowHost.dataset.sscChatBottom;
        changed = true;
      }
    } else if (shadowHost.style.bottom !== MOBILE_BOTTOM) {
      shadowHost.style.bottom = MOBILE_BOTTOM;
      shadowHost.dataset.sscChatBottom = '1';
      changed = true;
    }

    return changed;
  }

  function injectChatResizeStyles() {
    const shadowHost = document.querySelector(CHAT_SELECTOR);
    if (!shadowHost) return false;

    var changed = applyChatHostLayout(shadowHost);

    if (!shadowHost.shadowRoot) {
      if (changed) window.dispatchEvent(new CustomEvent('ssc:shopify-chat-resized'));
      return false;
    }

    const shadowRoot = shadowHost.shadowRoot;
    if (!shadowRoot.getElementById(STYLE_ID)) {
      const shStyle = document.createElement('style');
      shStyle.id = STYLE_ID;
      shStyle.textContent =
        'button.chat-toggle svg { height: 40px; } button.chat-toggle.chat-toggle--text-button { height: 40px; }';
      shadowRoot.appendChild(shStyle);
      changed = true;
    }

    if (changed) window.dispatchEvent(new CustomEvent('ssc:shopify-chat-resized'));
    return true;
  }

  function init() {
    if (injectChatResizeStyles()) return;

    const observer = new MutationObserver(function () {
      if (injectChatResizeStyles()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    mqDesktop.addEventListener('change', function () {
      if (injectChatResizeStyles()) return;
      const shadowHost = document.querySelector(CHAT_SELECTOR);
      if (shadowHost) {
        applyChatHostLayout(shadowHost);
        window.dispatchEvent(new CustomEvent('ssc:shopify-chat-resized'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
